import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import { createStyles, Grid, makeStyles, Typography } from "@material-ui/core";
import "jspdf-autotable";
import { CustomTheme } from "../../../../types/customTheme";
import WithLoading from "../../../../utils/WithLoading";
import CardCommon from "../../../../components/card/CardCommon";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import TextFieldCustom from "../../../../components/textField/TextFieldCustom";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import {
  createNewNotificationConfigInfo,
  updateNotificationConfigInfo,
} from "../../../../services/customerApp/customerDetails";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";

export interface CustomerNodeProps {
  isLoading: any;
  bannerNode: any;
  isOwner: any;
}

const useStyles = makeStyles((theme: CustomTheme) => createStyles({}));

const NotificationNode: React.FunctionComponent<CustomerNodeProps> = ({
  isLoading,
  bannerNode,
  isOwner,
}) => {
  const [notificationUrl, setNotificationUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!_.isEmpty(bannerNode)) {
      setNotificationUrl(bannerNode);
    }
  }, [bannerNode]);

  const match: any = useRouteMatch();

  const handleCreateNotification = async () => {
    try {
       let message = "";
      let body = {};
      let summaryString = "";

      summaryString = `Notification URL changed from ${bannerNode} to ${notificationUrl}`;
      message = "Customer Notification URL created";
      body = {
        message,
        summary: JSON.stringify(summaryString),
        type: "notification_map_config",
        code: "update",
        access_type: false,
        metadata: { changedBy: "" },
      };
      const res = await createNewNotificationConfigInfo(
        match.params.locationId,
        { url: notificationUrl },
        body,
        "customer",
      );
      setIsLoadingButton(false);
      setSuccess(SUCCESSFULLY_UPDATED);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const handleSubmit = () => {
    setIsLoadingButton(true);

    handleCreateNotification();
  };
  return (
    <>
      <CardCommon backgroundColor={"entity_background"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px",
          }}
        >
          <Typography variant="h5" align="left">
            Notification URL
          </Typography>
          <ButtonCommon
            onClick={handleSubmit}
            color={Object.keys(bannerNode).length > 0 ? "yellow" : "green"}
            style={{ width: "240px" }}
            isLoadingPage={isLoadingButton}
          >
            {Object.keys(bannerNode).length > 0
              ? "Update Notification"
              : "Create New Notification"}
          </ButtonCommon>
        </div>
        <div style={{ padding: "0px 12px 12px 12px" }}>
          <TextFieldCustom
            id="notificationUrl"
            name="notificationUrl"
            type="text"
            label={"Notification URL"}
            value={notificationUrl}
            disabled={false}
            onChange={(e: any) => {
              setErrorMessage("");
              setNotificationUrl(e.target.value ? e.target.value : "");
            }}
          />
          {errorMessage && <ValidationMessage message={errorMessage} />}
        </div>
      </CardCommon>
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity={"success"}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default WithLoading(NotificationNode);
